import { APP_CONFIG, USER_ROLES, FILTERS_CONFIG, APP_NOTIFICATION } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";
import { getXClientIdHeader } from "src/utils/getservicename";

type GetFiltersConfig = {
  fresh?: boolean;
  metricId?: string;
};

const categoryPageFilterConfig = {
  page: "Filters",
  config: {
    data: {
      meta: {
        endpoint: "/api/superset/explore_json/",
        queryParams: {
          form_data: JSON.stringify({ slice_id: 918 }),
        },
        credentials: "include",
        fieldIds: {
          Time_Slot: "timeSlotProcessor",
          business_unit: "businessProcessor",
        },
      },
      type: "AJAX_CALL",
    },
    children: [
      {
        meta: {
          label: "Businesses",
          value: [],
        },
        id: "business_unit",
        type: "TOGGLE_BUTTON_SET",
        events: {
          onChange: {
            type: "SET_VALUE",
          },
        },
      },
      {
        meta: {
          label: "Time Slots",
          value: [],
        },
        id: "Time_Slot",
        type: "TOGGLE_BUTTON_SET",
        events: {
          onChange: {
            type: "SET_VALUE",
          },
        },
      },
    ],
    id: "filtersPageLayout",
    type: "FILTER_PAGE_LAYOUT",
  },
};

export const getAppConfig = (): ApiResponse =>
  appFetch.get(APP_CONFIG, {
    headers: getXClientIdHeader(),
  });

export const getUserRoles = (): ApiResponse =>
  appFetch.get(USER_ROLES, {
    headers: getXClientIdHeader(),
  });

export const getUserCityPodMapping = (): ApiResponse =>
  appFetch.get("/api/anobis/getUserCityPodRoles", {
    headers: getXClientIdHeader(),
  });

export const getNotification = (): ApiResponse => appFetch.get(APP_NOTIFICATION, {});

export const getFiltersConfig = ({ metricId, fresh }: GetFiltersConfig): ApiResponse => {
  const headers = fresh ? { "X-Clear-Cache": "true", ...getXClientIdHeader() } : getXClientIdHeader();

  // for category page, metricId will be undefined and we should send the sample config with business unit and timeslot filters
  if (!metricId) {
    return Promise.resolve({
      error: null,
      response: categoryPageFilterConfig,
    });
  }
  return appFetch.get(`${FILTERS_CONFIG}/${metricId}`, { headers });
};
